const $ = jQuery.noConflict();

'use strict';
const LoadMoreProducts = {
	$domListing: $('.js-search-results-listing'), // Container holding the products
	$domLoader: $('.js-search-results-loader'), // Loader element
	isLoading: false, // Flag to prevent multiple requests
	hasLoaded: false, // Flag to stop after one load

	init: function() {
		// Only bind events if the products listing exists
		if (this.$domListing.length) {
			this.bindEvents();
		}
	},

	bindEvents: function() {
		const _this = this;

		// Bind the infinite scroll logic to the window's scroll event
		$(window).on('scroll', function() {
			_this.handleScroll();
		});
	},

	handleScroll: function() {
		// For testing purposes - stop if content has already been loaded once
		if (this.hasLoaded || this.isLoading) {
			return;
		}

		// Detect if the user has scrolled near the bottom of the product listing
		const scrollPosition = $(window).scrollTop() + $(window).height();
		const listBottom = this.$domListing.offset().top + this.$domListing.outerHeight();

		if (scrollPosition >= listBottom - 50) { // 50px buffer for smoother loading
			this.isLoading = true;
			this.showLoader();
		}
	},

	loadProductItems: function() {
		const _this = this;

		$.ajax({
			method: 'POST',
			url: window.fwsLocalized.ajaxUrl,
			data: {
				action: 'testAjaxData',
			},
			success: function(response) {
				_this.$domListing.append(response);
				_this.hasLoaded = true; // Stop further loading
			},
			error: function() {
				console.error('Failed to load products.');
			},
			complete: function() {
				_this.hideLoader();
				_this.isLoading = false; // Reset the loading flag
			}
		});
	},

	showLoader: function() {
		this.$domLoader.addClass('is-visible'); // Add a class to make the loader visible
	},

	hideLoader: function() {
		this.$domLoader.removeClass('is-visible'); // Remove the class to hide the loader
	}
};

export default LoadMoreProducts;
